import * as selectors from '../selectors';

const exporter = (state, materialId) => ({
  version: 'v2',
  material: [selectors.getMaterial(state, materialId)],
});

export default exporter;
